import {
  LoadingContainer,
  LegacyPage,
  Modal,
  ModelViewer,
  Panels,
  Bar,
  DateInput,
  NumericInput,
  Form,
} from 'peach/components'
import { useParams } from 'peach/router'

import { useDrawRatesGet, useDrawRatesAdd } from 'core/types'

import defaultDrawRate from './defaultDrawRate'

const DrawRates = () => {
  const { personId, loanId, drawId } = useParams<{
    personId?: string
    loanId?: string
    drawId?: string
  }>()

  const {
    data: drawRates,
    isLoading: isLoadingRates,
    error: ratesError,
  } = useDrawRatesGet({
    personId,
    loanId,
    drawId,
    options: { enabled: !!(personId && loanId && drawId) },
  })

  const { mutateAsync: createDrawRateMutate, isPending: isCreatingRate } =
    useDrawRatesAdd({
      personId,
      loanId,
      drawId,
    })

  const sendCreateDrawRate = async (formData) => {
    try {
      await createDrawRateMutate(formData)
    } catch (err) {
      console.error('Error creating draw rate:', err)
    }
  }

  return (
    <Panels header={<Bar title='Draw Rates' />}>
      <Modal
        initialValue={defaultDrawRate}
        onSubmit={sendCreateDrawRate}
        title='Create Draw Rate'
      >
        <Form.Provider formKey='promoRate' section>
          <NumericInput formKey='annualRate' />
          <DateInput formKey='startDate' />
          <DateInput formKey='endDate' />
        </Form.Provider>
        <Form.Provider formKey='interestRate' section>
          <NumericInput formKey='annualRate' />
          <DateInput formKey='startDate' />
          <DateInput formKey='endDate' />
        </Form.Provider>
      </Modal>
      <LoadingContainer
        error={ratesError}
        isLoading={isLoadingRates || isCreatingRate}
      >
        <LegacyPage.Full>
          <ModelViewer json={drawRates} />
        </LegacyPage.Full>
      </LoadingContainer>
    </Panels>
  )
}

export default DrawRates
